import { menuTypeAssignedCategoriesFactoryCore } from './chunk-T5LNLJ6X.mjs';
import { i18n_config_default } from './chunk-SGCJ7UYI.mjs';
import { __spreadProps, __spreadValues } from './chunk-T36PI2YV.mjs';

// src/helpers/factories/menu/cardFactories/menuTypes/menuTypesAssignedCatSubcategoriesFactory.ts
var menuTypesAssignedCatSubcategoriesFactory = (menuTypeItemAssociationIds, categories, categoryCount) => {
  const menuTypeItemAssociations = menuTypeAssignedCategoriesFactoryCore(
    menuTypeItemAssociationIds,
    categories
  ).map((menuTypeCategory) => {
    var _a, _b;
    return __spreadProps(__spreadValues({}, menuTypeCategory), {
      customTag: `${i18n_config_default.t("components.menuCard.tag.itemCount", {
        count: (_a = categoryCount.items[menuTypeCategory.id]) != null ? _a : 0
      })} | ${i18n_config_default.t("components.menuCard.tag.comboCount", {
        count: (_b = categoryCount.combos[menuTypeCategory.id]) != null ? _b : 0
      })}`,
      count: (categoryCount.items[menuTypeCategory.id] || 0) + (categoryCount.combos[menuTypeCategory.id] || 0)
    });
  });
  return menuTypeItemAssociations;
};

export { menuTypesAssignedCatSubcategoriesFactory };
